import { useEffect } from "react";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import classnames from "classnames";
import React from "react";
import GenericInput from "../../containers/helpers/genericInput";
import style from "../../styles/LoginInput.module.scss";
import styles from "../../styles/SignIn.module.scss";
import ForgotPassword from "../ForgotPassword";
import LoaderButton from "../LoaderButton";
import { useHistory } from "react-router-dom"

const ClientSignin = (props) => {
  const {
    fields,
    errorStateObject,
    isLoading,
    generalErrorText,
    resendCode,
    handlePasswordReset,
    showResetPassword,
    handleSubmit,
    handleFieldChange,
    resendVerificationCode,
    fromBBClient,
    passwordShown,
    togglePasswordVisiblity,
    scrollToSignup,
    isLoggedIn,
    curentUserName,
    handleSignout,
    productName,
  } = props;

  const firstInputTabRef = React.createRef();

  const history =  useHistory();
  
  useEffect(() => {
    if(isLoggedIn && !fromBBClient){
     
     history.push("/");

    }
    // eslint-disable-next-line
  },[isLoggedIn, !fromBBClient]) 

  const resetTab = () => {
    firstInputTabRef.current.focus();
  };

  const GeneralText = () => {
    if (generalErrorText.length) {
      return (
        <span className={classnames(styles.clientLoginText, styles.error)}>
          {generalErrorText}
        </span>
      );
    }
    //if forgot password show return to sign in
    if (showResetPassword) {
      return (
        <span
          className={classnames(styles.returnToSignIn, styles.link)}
          onClick={handlePasswordReset}
        >
          <img
            className={styles.arrow}
            src={"https://frontend-assets.buildbox.com/Arrow+Up.svg"}
            alt="Return to sign in"
          />
          Return to Sign In
        </span>
      );
    }
    if (isLoggedIn && !fromBBClient) {
      return (
        <div className={classnames(styles.clientLoginText, styles.signOut)}>
          {/* Looks like you're already logged in as: {curentUserName}. <br /> Did
          you want to{" "} */}
          Already logged in as: {curentUserName}. <br /> Did
          you want to{" "}
          <button className={styles.signOutText} onClick={handleSignout}>
            sign out?
          </button>
        </div>
      );
    }

    let welcomeText = "Welcome to Buildbox"
    if(productName && productName.toLowerCase().includes("soundbox")) {
      welcomeText = "Welcome to Soundbox"
    }
    return (
      <span className={styles.clientLoginText}> {welcomeText} </span>
    );
  };
  const inputStyles = {
    container: style.loginContainer,
    label: style.loginInputLabel,
    input: style.loginInput,
    error: style.loginInputError,
    icon: styles.passwordIcon,
  };

  return (
    <div className={styles.signIn} id={"signin"}>
      <GeneralText />
      {showResetPassword ? (
        <ForgotPassword fromBBClient passwordReset={handlePasswordReset} />
      ) : (
        <>
          <form onSubmit={handleSubmit}>
            <GenericInput
              type={"text"}
              placeholder={"Username"}
              inputName={"username"}
              errorState={errorStateObject.username}
              inputValue={fields.username}
              changeCallback={handleFieldChange}
              styles={inputStyles}
              ref={firstInputTabRef}
            />
            <GenericInput
              type={passwordShown ? "text" : "password"}
              placeholder={"Password"}
              inputName={"password"}
              errorState={errorStateObject.password}
              inputValue={fields.password}
              changeCallback={handleFieldChange}
              styles={inputStyles}
              icon={passwordShown ? faEye : faEyeSlash}
              iconClickHandler={togglePasswordVisiblity}
            />
            {resendCode ? (
              <span
                className={styles.resendCodeLink}
                onClick={resendVerificationCode}
              >
                Resend Code
              </span>
            ) : (
              <button
                className={styles.forgotPasswordBtnClient}
                onClick={handlePasswordReset}
                type="button"
              >
                Forgot password?
              </button>
            )}
            <LoaderButton
              isLoading={isLoading}
              onClick={handleSubmit}
              onBlurCallback={resetTab}
            >
              Log In
            </LoaderButton>
          </form>
          <button
            id={"signupBtn"}
            className={styles.signInButtonClient}
            onClick={scrollToSignup}
          >
            <span> Create an Account</span>
          </button>
        </>
      )}
    </div>
  );
};

export default ClientSignin;
